import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=0dca8b1a&scoped=true&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=0dca8b1a&scoped=true&lang=css&"
import style1 from "./ChangePassword.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dca8b1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dca8b1a')) {
      api.createRecord('0dca8b1a', component.options)
    } else {
      api.reload('0dca8b1a', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=0dca8b1a&scoped=true&", function () {
      api.rerender('0dca8b1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/authentication/forms/ChangePassword.vue"
export default component.exports